import { Injectable, Inject } from '@angular/core';
import { ServiceConfigurationLoadedStateManager } from './service-configuration-loaded.service';
import {
  ServiceRequestLoadedStateManager,
  DraftServiceRequestLoadedStateManager,
  FormsDefinedStateManager,
  DraftServiceRequestSavedStateManager,
  ServiceRequestUpdatedStateManager,
  ServiceRequestCreatedStateManager,
  InvalidFlowStateManager,
  SuccessfulFlowStateManager,
  InvalidServiceRequestSubmitStateManager,
  FlowStateManager,
  PaymentGatewayStateManager,
  PaymentConfirmedStateManager,
  PaymentErrorStateManager,
  WorkflowStartedStateManager,
  ServicePageLandedStateManager,
} from './service-request-loaded.service';
import { ApplicantStateService } from '../ApplicantState.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { UtilService } from 'src/app/core/utilities/util.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ServiceMetadataGetCustomDetailService } from 'src/app/core/api-services/portal/service-metadata-get-custom-details.service';
import { EsCommonService } from 'src/app/core/api-services/shared/es-common.service';
import { DOCUMENT } from '@angular/common';
import { AnalyticsListenersService } from '../analytics-management/analytics.listeners.service';
import { ProcedureInstanceListenersService } from '../analytics-management/procedure-instance-listeners.service';
import { ServiceMetadataLoadedStateManager } from './service-metadata-loaded-state.service';

@Injectable()
export class DispatchersFacadeService {
  constructor(
    @Inject('serviceConfigurationLoadedStateManager')
    public serviceConfigurationLoaded: ServiceConfigurationLoadedStateManager,
    @Inject('serviceRequestLoadedStateManager')
    public serviceRequestLoaded: ServiceRequestLoadedStateManager,
    @Inject('serviceRequestUpdatedStateManager')
    public serviceRequestUpdated: ServiceRequestUpdatedStateManager,
    @Inject('serviceRequestCreatedStateManager')
    public serviceRequestCreated: ServiceRequestCreatedStateManager,
    @Inject('draftServiceRequestLoadedStateManager')
    public draftRequestLoaded: DraftServiceRequestLoadedStateManager,
    @Inject('draftServiceRequestSavedStateManager')
    public draftRequestSaved: DraftServiceRequestSavedStateManager,
    @Inject('formsDefinedStateManager')
    public formsDefined: FormsDefinedStateManager,
    @Inject('invalidFlowManager')
    public invalidFlow: InvalidFlowStateManager,
    @Inject('invalidServiceRequestSubmitManager')
    public invalidServiceRequestSubmitManager: InvalidServiceRequestSubmitStateManager,
    @Inject('successfulFlow')
    public successfulFlow: SuccessfulFlowStateManager,
    @Inject('flow')
    public flow: FlowStateManager,
    @Inject('paymentGateway')
    public paymentGateway: PaymentGatewayStateManager,
    @Inject('paymentConfirmed')
    public paymentConfirmed: PaymentConfirmedStateManager,
    @Inject('paymentError')
    public paymentError: PaymentErrorStateManager,
    @Inject('workflowStarted')
    public workflowStarted: WorkflowStartedStateManager,
    @Inject('servicePageLanded')
    public servicePageLanded: ServicePageLandedStateManager,
    @Inject('serviceMetadataLoaded')
    public serviceMetadataLoaded: ServiceMetadataLoadedStateManager,
  ) {}
}

@Injectable()
export class NativesFacadeService {
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    @Inject(DOCUMENT)
    public document: Document,
    public platform: Platform,
  ) {}
}

@Injectable()
export class UtilsFacadeService {
  constructor(
    public utilService: UtilService,
    public translateService: TranslateService,
    public toastr: ToastrService,
  ) {}
}

@Injectable()
export class ApisFacadeService {
  constructor(
    public metadataService: ServiceMetadataGetCustomDetailService,
    public commonApiService: EsCommonService,
  ) {}
}

@Injectable()
export class StatesFacadeService {
  constructor(
    @Inject('applicantStateService')
    public applicantStateService: ApplicantStateService,
    @Inject('analyticsListenersService')
    public analyticsListenersService: AnalyticsListenersService,
    @Inject('procedureInstanceListenersService')
    public procedureInstanceListenersService: ProcedureInstanceListenersService,
  ) {}
}
